import React from "react";
import { useIntl, defineMessages } from "react-intl";
import { Link } from "react-router-dom";

import { useActionStyles } from "../mainHeader";
import IconButton from "@material-ui/core/IconButton";
import GearIcon from "../../common/icons/gearIcon";

const messages = defineMessages({
    settingsTooltip: {
        id: "main-header.settings-tooltip",
        defaultMessage: "Settings",
        description: "Settings main header toottip",
    },
});

export const Settings = (props) => {
    const intl = useIntl();
    const classes = useActionStyles();

    return (
        <IconButton aria-describedby="user-settings" className={classes.menuButton} component={Link} to="/settings">
            <GearIcon color="white" title={intl.formatMessage(messages.settingsTooltip)} />
        </IconButton>
    );
};

export default Settings;
